import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export default function TestPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <CheckCircle className="w-6 h-6 text-green-500" />
              Deployment Test Page
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-lg">✅ If you can see this page, the deployment is working!</p>
            
            <div className="space-y-2">
              <p className="font-semibold">Test Navigation:</p>
              <div className="flex flex-wrap gap-2">
                <Link to="/manage/dashboard">
                  <Button>Go to Dashboard</Button>
                </Link>
                <Link to="/manage/suppliers">
                  <Button variant="outline">Suppliers</Button>
                </Link>
                <Link to="/manage/products">
                  <Button variant="outline">Products</Button>
                </Link>
                <Link to="/">
                  <Button variant="secondary">Home</Button>
                </Link>
              </div>
            </div>

            <div className="mt-6 p-4 bg-muted rounded-lg">
              <p className="text-sm text-muted-foreground">
                Build Time: {new Date().toISOString()}
              </p>
              <p className="text-sm text-muted-foreground">
                Route: /test
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
